import helper from './helper'

export default {
  getById(id) {
    return helper.get(`/affiliate-teams/${id}`)
  },
  getByEventEntry(id) {
    return helper.get(`/affiliate-teams/evententry/${id}`)
  }
}
